import React from "react";
import { convertToNumber } from "utils/numberExtension";

const DANH_SACH_NUT = [
  { label: "-5", tinh: (v) => v - 5000000 },
  { label: "+5", tinh: (v) => v + 5000000 },
  { label: "10", tinh: () => 10000000 },
  { label: "20", tinh: () => 20000000 },
  { label: "30", tinh: () => 30000000 },
  { label: "40", tinh: () => 40000000 },
  { label: "50", tinh: () => 50000000 },
];

// getValue đọc lúc bấm vì các form mutate choVayEdit tại chỗ, prop value có thể stale
const NutNhanhSoTienVay = ({ getValue, onChange, disabled }) => (
  <div
    style={{
      display: "flex",
      flexWrap: "wrap",
      gap: "6px",
      paddingTop: "36px",
    }}
  >
    {DANH_SACH_NUT.map((item) => (
      <button
        key={item.label}
        type="button"
        className="btn btn-sm btn-new-main btn-checknew"
        style={{ minWidth: "48px" }}
        disabled={disabled}
        onClick={() =>
          onChange(Math.max(0, item.tinh(convertToNumber(getValue()))))
        }
      >
        {item.label}
      </button>
    ))}
  </div>
);

export default NutNhanhSoTienVay;
